var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1204_75208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2733 7.71967L8.27325 1.71967C8.03325 1.47967 7.69992 1.33301 7.33325 1.33301H2.66659C1.93325 1.33301 1.33325 1.93301 1.33325 2.66634V7.33301C1.33325 7.69967 1.47992 8.03301 1.72659 8.27967L7.72659 14.2797C7.96659 14.5197 8.29992 14.6663 8.66659 14.6663C9.03325 14.6663 9.36659 14.5197 9.60659 14.273L14.2733 9.60634C14.5199 9.36634 14.6666 9.03301 14.6666 8.66634C14.6666 8.29967 14.5133 7.95967 14.2733 7.71967ZM8.66659 13.3397L2.66659 7.33301V2.66634H7.33325V2.65967L13.3333 8.65967L8.66659 13.3397Z",
    fill: "#007683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 5.33301C4.88554 5.33301 5.33325 4.88529 5.33325 4.33301C5.33325 3.78072 4.88554 3.33301 4.33325 3.33301C3.78097 3.33301 3.33325 3.78072 3.33325 4.33301C3.33325 4.88529 3.78097 5.33301 4.33325 5.33301Z",
    fill: "#007683"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1204_75208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalOffer);
export default __webpack_public_path__ + "static/media/local_offer.5bfb9cc5bfc148eab7c257c3acfe8bb0.svg";
export { ForwardRef as ReactComponent };